import { ActionBase } from '../../../core/store/action/ActionBase';

export const GET_SUPPORT_TICKET_INFORMATION_ACTION = '[Configuration] Get Support Ticket Information Action';

export class GetSupportTicketInformationAction implements ActionBase {
  readonly identifier = new Date().getTime().toString();
  readonly type = GET_SUPPORT_TICKET_INFORMATION_ACTION;

  constructor() {}
}



// WEBPACK FOOTER //
// ./src/app/security/store/actions/GetSupportTicketInformationAction.ts